
<template>
<div>
  <chc-loader ref="loader"></chc-loader>
  <datatable
    :source='charities'
    :isLoading='isLoading'
    :searchCallback='searchCallback'
    >
    <datatable-column
      v-for='(column, index) in columns'
      :id='column.id'
      :label='column.label'
      :key='index'
      :sortKey="column.sort"
      >
    </datatable-column>

    <datatable-filter
      :id='status.id'
      :label='status.label'
      :options='status.options'
      :defaultFilter="status.default"
      ref="statusFilter"
      @addFilter="addFilter"
      @removeFilter="removeFilter"
      >
    </datatable-filter>

    <template slot="searchLeft">
      <a class="secondary-action" v-on:click="addCharity">+ Add Charity</a>
    </template>

    <template slot="source_template" slot-scope="data">
      <tr @click="gotoRow(data.row.id)">
        <td>{{ data.row.name }}</td>
        <td>{{ data.row.address }}</td>
        <td>{{ data.row.state }}</td>
        <td>{{ data.row.phone }}</td>
        <td>{{ data.row.vehicle_count_ytd }}</td>
        <td>{{ data.row.lifetime_vehicle_count }}</td>
        <td>{{ data.row.ytd_proceeds }}</td>
        <td>{{ data.row.status }}</td>
      </tr>
    </template>
  </datatable>
</div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import DatatableFilter from '@/components/Datatables/AppDatatableFilter'
import store from '@/store'

export default {
  name: 'CharitiesSummary',
  mounted () {
    Promise.all([
      store.functions.charity.charityTable((response) => {
        this.charities = response.data.table_data
        this.status.options = Object.values(response.data.status_filter)
        this.status.default = Object.values(response.data.initial_filter)
        this.filters = Object.values(response.data.initial_filter)
        store.storage.charities_status = this.status
        store.storage.charities_filters = this.filters
        this.$nextTick(() => {
          this.$refs.statusFilter.init()
        })
      })
    ]).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      columns: [
        { id: 'name', label: 'Charity Name' },
        { id: 'address', label: 'Address' },
        { id: 'state', label: 'State' },
        { id: 'phone', label: 'Phone' },
        { id: 'vehicle_count_ytd', label: 'Vehicle Count YTD' },
        { id: 'lifetime_vehicle_count', label: 'Lifetime Vehicle Count' },
        { id: 'ytd_proceeds', label: 'YTD Proceeds', sort: 'ytd_proceeds_cents' },
      ],
      isLoading: true,
      charities: [],
      status: {
        id: 'status',
        label: 'Status',
        options: [],
        default: []
      },
      filters: [],
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    DatatableFilter,
  },
  methods: {
    gotoRow (rowId) {
      this.$refs.loader.show()
      this.$router.push({name: 'Charity', params: {charityId: rowId}}, () => {
        this.$refs.loader.hide()
      })
    },
    addCharity () {
      this.$router.push({name: 'CharityAdd'})
    },
    addFilter (option) {
      let index = this.filters.indexOf(option)
      if (index === -1) {
        this.filters.push(option)
      }
      this.refresh()
    },
    removeFilter (option) {
      let index = this.filters.indexOf(option)
      if (index !== -1) {
        this.filters.splice(index, 1)
      }
      this.refresh()
    },
    searchCallback (filter) {
      this.refresh(filter)
    },
    refresh (filter = '') {
      this.isLoading = true
      store.functions.charity.charityTable((response) => {
        this.charities = response.data.table_data
        this.status.options = Object.values(response.data.status_filter)
        this.status.default = Object.values(response.data.initial_filter)
        store.storage.charities_status = this.status
        store.storage.charities_filters = this.filters
        this.$nextTick(() => {
          this.$refs.statusFilter.init()
        })
      }, JSON.stringify(this.filters), filter)
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charity/CharitiesSummary.vue